import { keyframes } from '@emotion/react';
import { OriflameSpinner } from '@ori-ui/icons';
import { styled, alpha } from '@ori-ui/mui';
import type { FC } from 'react';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Root = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(13),
  bottom: theme.spacing(9),
  width: '100%',
  height: `calc(100% - ${theme.spacing(28)})`, // 100% - (header + footer height)
  background: alpha(theme.palette.common.white, 0.5),
  zIndex: 999,
}));

const Wrapper = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

const Spinner = styled(OriflameSpinner)({
  animation: `${spin} 1s linear infinite`,
});

const Loader: FC = () => (
  <Root>
    <Wrapper>
      <Spinner
        fontSize="large"
        color="secondary"
      />
    </Wrapper>
  </Root>
);

export default Loader;
